import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=d6ce2ec6"
import script from "./CopyField.vue?vue&type=script&lang=js"
export * from "./CopyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports